/* this file is transformed by vux-loader */
/* eslint-disable */
import _regenerator from "E:/pm-ningde/ppos-web-propertyManage/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "E:/pm-ningde/ppos-web-propertyManage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Flexbox from "vux/src/components/flexbox/flexbox.vue";
import FlexboxItem from "vux/src/components/flexbox/flexbox-item.vue";
import Xhead from '@/components/XHeader';
import { workOrderInfo, actionReview } from '@/api/exammine';
import { fileDownload } from '@/api/common';
import Vue from 'vue';
export default {
  components: {
    Xhead: Xhead,
    Flexbox: Flexbox,
    FlexboxItem: FlexboxItem
  },
  data: function data() {
    return {
      bigImgSrc: '',
      bigShadow: false,
      timeOut: null,
      showShadow: false,
      title: '工单审核',
      handler_info: {},
      // 处理信息
      initial_info: {},
      // 基础信息
      reviewer_info: {},
      // 审核信息
      related_no: '',
      remark: '',
      type: '',
      // 工单类型 type(1:工作监督,问题反馈工单；2：装修申请工单；3：装修问题工单)
      status: '',
      // status状态(0：待处理；1：待审核；2：审核通过；3：审核不通过；4：反馈取消)
      actionStatus: '',
      // { name: '待我处理的', id: '0' }, { name: '我已处理的', id: '1' }
      status_str: ''
    };
  },
  mounted: function mounted() {
    this.related_no = this.$route.query.related_no;
    this.actionStatus = this.$route.query.status;
    this.getOrderDetail();
  },
  methods: {
    // // 展示下载附件
    // showFileDownload(item) {
    //   if (!item.attachment_path) {
    //     Vue.$vux.toast.show({
    //       type: 'warn',
    //       text: '该文件下载路径有误,无法下载',
    //       time: 2000
    //     })
    //     return
    //   }
    //   const param = {
    //     file_path: item.attachment_path
    //   }
    //   this.getFileDownload(param, item)
    // },
    // async getFileDownload(param, item) {
    //   this.showShadowEvent('数据连接中')
    //   const data = await fileDownload(param)
    //   this.hideShadowEvent()
    //   if (data.size !== 88) {
    //     const content = data
    //     const blob = new Blob([content])
    //     const fileName = item.attachment_name
    //     if ('download' in document.createElement('a')) { // 非IE下载
    //       const elink = document.createElement('a')
    //       elink.download = fileName
    //       elink.style.display = 'none'
    //       elink.href = URL.createObjectURL(blob)
    //       document.body.appendChild(elink)
    //       elink.click()
    //       URL.revokeObjectURL(elink.href) // 释放URL 对象
    //       document.body.removeChild(elink)
    //     } else {
    //       navigator.msSaveBlob(blob, fileName)
    //     }
    //   } else {
    //     Vue.$vux.toast.show({
    //       type: 'warn',
    //       text: '该账号无导出项目权限',
    //       time: 2000
    //     })
    //   }
    // },
    showBigPic: function showBigPic(url) {
      if (!url) {
        return;
      }
      url = url.split('?')[0];
      // url = url + '?w=200&h=1200'
      this.bigImgSrc = url;
      this.bigShadow = true;
    },
    hideBigPic: function hideBigPic(url) {
      this.bigShadow = false;
      this.bigImgSrc = '';
    },
    goBack: function goBack() {
      // 返回
      var routerParam = {
        name: 'Examine',
        query: {
          status: this.actionStatus
        }
      };
      this.$router.push(routerParam);
    },
    handlerFail: function handlerFail() {
      var param = {
        related_no: this.related_no,
        remark: this.remark,
        review_type: 2 // 审核结果类型（1：审核通过；2：审核不通过）
      };
      this.getActionReview(param);
    },
    handlerOk: function handlerOk() {
      var param = {
        related_no: this.related_no,
        remark: this.remark,
        review_type: 1 // 审核结果类型（1：审核通过；2：审核不通过）
      };
      this.getActionReview(param);
    },
    getOrderDetail: function getOrderDetail() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var param, _yield$workOrderInfo, handler_info, initial_info, reviewer_info, type, type_str, status, status_str;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              param = {
                related_no: _this.related_no
              };
              _context.n = 1;
              return workOrderInfo(param);
            case 1:
              _yield$workOrderInfo = _context.v;
              handler_info = _yield$workOrderInfo.handler_info;
              initial_info = _yield$workOrderInfo.initial_info;
              reviewer_info = _yield$workOrderInfo.reviewer_info;
              type = _yield$workOrderInfo.type;
              type_str = _yield$workOrderInfo.type_str;
              status = _yield$workOrderInfo.status;
              status_str = _yield$workOrderInfo.status_str;
              _this.initial_info = initial_info;
              _this.handler_info = handler_info;
              _this.reviewer_info = reviewer_info;
              _this.status = status;
              _this.status_str = status_str;
              _this.type = type;
              _this.title = type_str;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    getActionReview: function getActionReview(param) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _yield$actionReview, is_error, msg, error;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (_this2.remark) {
                _context2.n = 1;
                break;
              }
              Vue.$vux.toast.show({
                type: 'warn',
                text: '请填写审批说明后再操作',
                time: 2000
              });
              return _context2.a(2);
            case 1:
              _this2.showShadowEvent('数据上传中');
              _context2.n = 2;
              return actionReview(param);
            case 2:
              _yield$actionReview = _context2.v;
              is_error = _yield$actionReview.is_error;
              msg = _yield$actionReview.msg;
              error = _yield$actionReview.error;
              _this2.hideShadowEvent();
              Vue.$vux.toast.show({
                type: !is_error ? 'success' : 'warn',
                text: msg || error,
                time: 2000
              });
              if (!is_error) {
                _this2.goBack();
              }
            case 3:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    showShadowEvent: function showShadowEvent(text) {
      var _this3 = this;
      // 显示
      this.$vux.loading.show({
        text: text
      });
      this.showShadow = true;
      this.timeOut = setTimeout(function () {
        _this3.$vux.loading.hide();
        _this3.showShadow = false;
      }, 10000);
    },
    hideShadowEvent: function hideShadowEvent() {
      clearTimeout(this.timeOut);
      this.timeOut = null;
      // 隐藏
      this.$vux.loading.hide();
      this.showShadow = false;
    }
  }
};